import React from 'react';
import './style.css';

export const HowToPurchaseItem = ({ description, icon, number, title, index }) => {
  return (
    <div className="htp-step" style={{ animationDelay: `${index * 0.15}s` }}>
      <div className="htp-step-number-ring">
        <span className="htp-step-number">{number}</span>
      </div>
      <div className="htp-step-icon">
        {icon}
      </div>
      <h3 className="htp-step-title">{title}</h3>
      <p className="htp-step-description">{description}</p>
    </div>
  );
};
